export const info = {
  product: {
    noRecords: 'No hay productos para mostrar',
  },
};
